export default "__VITE_ASSET__$n4zeMlQ__"